import debug from 'debug';
import DictionaryObject from 'Global/Shared/Components/Sitecore/DictionaryObject';

const log = debug('FrontPageCatalogs:Templates:SortingTypeTemplates');

class SortingTypeTemplates {

	constructor() {
		this.dictionary = new DictionaryObject({
			dictionaryUrl: 'Forum_dk/AdvertUI/MtCustomerCatalogs',
			includeDescendants: false
		});
	}

	base() {
		return `
			<div class="o-front-page-catalogs-sorting-type">
				<ul class="o-front-page-catalogs-sorting-type__container" data-ref="catalogs-sorting__container"></ul>
			</div>
		`;
	}

	dictionaryInit() {
		return this.dictionary.Get();
	}

	dictionaryText(phrase) {
		return this.dictionary.Text(phrase);
	}

	/**
	 * @param {Object} options 
	 * @param {string} [options.customCssClass]
	 * @param {boolen} [options.disabled]
	 * @param {element} options.icon
	 * @param {string} options.label
	 * @param {boolean} options.selected
	 * @param {string} options.type sorting type
	 */
	sortingOption(options) {
		return `
			<li class="o-front-page-catalogs-sorting-type__option ${options.customCssClass !== undefined ? options.customCssClass : ''}">
				<a href="#" class="o-front-page-catalogs-sorting-type__option-link ${options.selected ? 'is-selected' : ''} ${options.disabled ? 'is-disabled' : ''}" 
					data-type="${options.type}" data-js="catalogs-sorting-type">
					<span class="o-front-page-catalogs-sorting-type__icon">${options.icon}</span>
					<span class="o-front-page-catalogs-sorting-type__label">${options.label}</span>
					<span class="a-switch"></span>
				</a>
			</li>
		`;
	}
}

export default SortingTypeTemplates;
